export class Route {
    get checkpoints() {
        return [...this._checkpoints];
    }
    get firstCheckpoint() {
        return this._checkpoints[0];
    }
    get lastCheckpoint() {
        return this._checkpoints[this._checkpoints.length - 1];
    }
    constructor(id, representation, name, surname, image, trivialIcons, color, meta, path, _checkpoints) {
        this.id = id;
        this.representation = representation;
        this.name = name;
        this.surname = surname;
        this.image = image;
        this.trivialIcons = trivialIcons;
        this.color = color;
        this.meta = meta;
        this.path = path;
        this._checkpoints = _checkpoints;
    }
    getTrivialIcon(version) {
        return this.trivialIcons[version];
    }
    getBounds() {
        let north, east, south, west;
        for (const [lon, lat] of this.path) {
            if (north === undefined || north < lat)
                north = lat;
            if (south === undefined || south > lat)
                south = lat;
            if (west === undefined || west > lon)
                west = lon;
            if (east === undefined || east < lon)
                east = lon;
        }
        for (const { coordinates } of this._checkpoints) {
            if (north === undefined || north < coordinates.lat)
                north = coordinates.lat;
            if (south === undefined || south > coordinates.lat)
                south = coordinates.lat;
            if (west === undefined || west > coordinates.lon)
                west = coordinates.lon;
            if (east === undefined || east < coordinates.lon)
                east = coordinates.lon;
        }
        return [west, south, east, north];
    }
}
